module.exports = "/_next/static/resources/sourcing-da67a728bb1c6164b6e67d44aeafe068.webp";